<template>
  <section class="warranty_tiers">
    <div class="container">
      <div class="warranty_tiers__inner" :class="[tierCount]">
        <div
          class="warranty_tiers__inner__text"
          v-for="(tier, index) in parsedtiers"
          :key="index"
          :class="tier.theme"
        >
          <p class="title" v-if="tier.title" v-html="tier.title"></p>
          <p class="tag" v-if="tier.tag" v-html="tier.tag"></p>

          <ul v-if="tier.features">
            <li
              v-for="(feature, index) in tier.features"
              :key="index"
              v-html="feature.feature"
            ></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      theModalStatus: false,
    };
  },

  props: {
    title: {},
    text: {},
    secondary_button: {},
    tiers: {},
  },

  computed: {
    parsedtiers() {
      if (this.tiers) {
        return JSON.parse(this.tiers);
      } else {
        return null;
      }
    },

    tierCount() {
      if (this.parsedtiers.length === 2) {
        return 'two';
      } else if (this.parsedtiers.length === 3) {
        return 'three';
      } else {
        return 'four';
      }
    },
  },

  watch: {},

  methods: {
    getModalData(arg) {
      this.theModalStatus = arg;
      return arg;
    },
  },

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.warranty_tiers {
  /* overflow: hidden; */

  @media (max-width: $mobile-xl) {
    padding: 0;
  }

  /* .container {
		@media (max-width: $mobile-xl) {
			padding: 0;
			margin: 0;
			max-width: 100%;
		}
	} */

  &__inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    grid-column: 1 / span 12;

    @media (max-width: $mobile-xl) {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 16px;
      grid-column: span 4;
    }

    &.two {
      grid-template-columns: 1fr 1fr;
      grid-column: 1 / span 12;

      @media (max-width: $mobile-xl) {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 16px;
        grid-column: span 4;

        .warranty_tiers__inner__text {
          grid-column: span 1;
        }
      }

      @media (max-width: $mobile) {
        grid-template-columns: 1fr;
        column-gap: 0;
        row-gap: 16px;
        grid-column: span 4;

        .warranty_tiers__inner__text {
          grid-column: span 1;
        }
      }
    }

    &.three {
      grid-template-columns: 1fr 1fr 1fr;
      grid-column: 1 / span 12;

      @media (max-width: $mobile-xl) {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 16px;
        grid-column: span 4;

        .warranty_tiers__inner__text {
          grid-column: span 1;
        }
      }

      @media (max-width: $mobile) {
        grid-template-columns: 1fr;
        column-gap: 0;
        row-gap: 16px;
        grid-column: span 4;

        .warranty_tiers__inner__text {
          grid-column: span 1;
        }
      }
    }

    &.four {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-column: 1 / span 12;

      @media (max-width: $mobile-xl) {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 16px;
        grid-column: span 4;

        .warranty_tiers__inner__text {
          grid-column: span 1;
        }
      }

      @media (max-width: $mobile) {
        grid-template-columns: 1fr;
        column-gap: 0;
        row-gap: 16px;
        grid-column: span 4;

        .warranty_tiers__inner__text {
          grid-column: span 1;
        }
      }
    }

    &__text {
      grid-column: span 1;
      opacity: 1;
      font: normal normal 300 18px/28px var(--primary-font-family);
      position: relative;
      overflow: hidden;
      padding: 24px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

      @media (max-width: $mobile-xl) {
        gap: var(--gutter-mobile);
        order: 1;
      }

      p {
        margin: 0;

        &::v-deep {
          p,
          li,
          a,
          span {
            color: var(--dark-purple);
          }
        }

        &.title {
          font: normal normal 600 24px/28px var(--primary-font-family);
        }

        &.tag {
          background: var(--green);
          display: inline-flex;
          margin: 20px 0 0;
          padding: 5px 10px;
          font-weight: bold;
          color: var(--purple);
        }
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 20px 0 0;

        li {
          &::v-deep {
            color: #636363;
          }

          &:before {
            content: '-';
            margin-right: 10px;
          }
        }
      }

      .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(.has-image) {
          height: 100%;
        }
      }

      .content_container {
        padding: 20px 30px;

        @media (max-width: $mobile-xl) {
          padding: 16px;
        }
      }

      a {
        color: var(--green);
        font-size: 16px;
        font-weight: 400;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      .content_device {
        position: absolute;
        right: 0;
        bottom: 0;

        @media (max-width: $mobile-xl) {
          height: 112px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/WarrantyTiers.vue